import { WatcherFunction } from '..'
import { watchMediaUpload } from './upload'

export const mediaSagas: ReadonlyArray<WatcherFunction> = [watchMediaUpload]
